import { observer } from "mobx-react-lite";
import styles from "./index.module.less";
import React, { HTMLAttributes, useCallback, useEffect, useMemo, useState } from "react";
import cx from "classnames";
import { Hooks } from "@xt/xtbase";
import QrCode from "@xt/QrCode";
import { post_promotionChannelTrace, getAppVersions } from "@/api/xt-app";
const { useTranslation } = Hooks;
interface Props extends HTMLAttributes<HTMLDivElement> {
  attr?: any;
}

const Main: React.FC<Props> = ({ className }) => {
  const t = useTranslation();
  const [channelId, setChannelId] = useState("");
  const [appList, setAppList] = useState([]);
  const downSourceArr = useMemo(
    () => [
      {
        code: "ios",
        noshow: "ios",
        title: "APP Store",
        subtitle: "Download on the",
        icon: require("@/assets/images/app/ios.svg").default,
      },
      {
        code: "android-google-play",
        noshow: "android-google-play",
        title: "Google Play",
        subtitle: "GET IT ON",
        icon: require("@/assets/images/app/google-play.svg").default,
      },
      {
        code: "android",
        noshow: "android",
        title: "Android APK",
        subtitle: "Download for",
        icon: require("@/assets/images/app/android.svg").default,
      },
    ],
    [channelId]
  );

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);

    const id = searchParams.get('channelId');

     
      
    setChannelId(id);
  }, []);

    const promotionChannelTrace = useCallback((action = "view") => {
       
    return post_promotionChannelTrace({
      data: { action: /^(view|click)$/.test(action), channelId },
      isAutoPopError: false,
    });
  }, []);

  const handleDownload = () => promotionChannelTrace("click");

  useEffect(() => {
    if (!channelId) return;
    promotionChannelTrace();
  }, [channelId]);

  return (
    <div className={cx(styles.main, className)} style={{ backgroundImage: `url(${require("@/assets/images/app/app-down-bg.png")})` }}>
      <div className={styles.downContainer}>
        <img className={styles.baseImg} src={require("@/assets/images/app/app-mob.png")} alt="" />
        <div className={styles.content}>
          <div className={styles.contentTitle}>
            <h3>{t("group.first-hand24HMarket")}</h3>
            <h3>{t("group.TradeAnywhere")}</h3>
          </div>
          <div className={styles.contentBtns}>
            {downSourceArr.map((item, i) => (
              <a
                className={styles.item}
                key={i}
                href={(appList.find((app) => app.client == item.noshow) || { url: "" }).url}
                onClick={handleDownload}
                target="_blank"
              >
                <img src={item.icon} alt="" />
                <div className={styles.title}>
                  <p>{item.subtitle}</p>
                  <b>{item.title}</b>
                </div>
              </a>
            ))}
          </div>
          <div className={styles.contentQrcode}>
            <div className={styles.qrcodeContainer}>
              <QrCode size={100} isShowLogo={false} margin={0} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default observer(Main);
